import TicketAvatar from 'flow/components/tickets/TicketAvatar';
import { ExtensionKey } from 'flow/types/EntityKeys';
import useAppContext from 'flow/hooks/useAppContext';
import { useAppSelector } from 'flow/hooks/useRedux';
import { State } from 'flow/types/State';
import { selectContactName } from 'flow/selectors/ExtensionSelectors';

interface Props {
    assigneeExtensionKey: ExtensionKey;
}

const AssigneeItem = ({ assigneeExtensionKey }: Props) => {
    const { i18next } = useAppContext();
    const assigneeName = useAppSelector((state: State) =>
        selectContactName(state, assigneeExtensionKey),
    );

    return (
        <div className="flex items-center gap-x-2">
            <TicketAvatar
                extensionKey={assigneeExtensionKey}
                size={'small'}
                lazyLoad={true}
            />

            <span className="truncate">
                {assigneeName || i18next.t('Contact.Unknown')}
            </span>
        </div>
    );
};

export default AssigneeItem;
